module.exports = __webpack_public_path__ + "static/media/buzzwords_start.0aa8cc82.png";